export default __webpack_public_path__ + "static/media/candidate_register.6672dee9.svg";